import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./user.service";
const url = environment.ruta;
export class AuthenticationService {
    constructor(http, userSirvice) {
        this.http = http;
        this.userSirvice = userSirvice;
        this.confirmacion = {
            estatus: false,
            mensaje: ''
        };
    }
    isAuthenticated() {
        return localStorage.getItem('autenticacion_token') != null && !this.isTokenExpired();
    }
    isTokenExpired() {
        return false;
    }
    iniciarSesion(info) {
        const encabezado = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf8'
        });
        return this.http.post(`${url}ValidarUsuario/`, info, { headers: encabezado })
            .pipe(map(resultado => {
            if (resultado && resultado.info) {
                localStorage.clear();
                // store resultado details and jwt token in local storage to keep resultado logged in between page refreshes
                localStorage.setItem('autenticacion_token', resultado.info.token);
                this.getDecodedToken();
                this.confirmacion.estatus = true;
                this.confirmacion.mensaje = resultado.mensaje;
            }
            else {
                this.confirmacion.estatus = false;
                this.confirmacion.mensaje = resultado.mensaje;
            }
            return this.confirmacion;
        }));
    }
    iniciarSesionFirmaElectronica(info) {
        return this.http.post(`${url}ValidarFirma/`, info)
            .pipe(map(resultado => {
            if (resultado && resultado.info) {
                // store resultado details and jwt token in local storage to keep resultado logged in between page refreshes
                localStorage.setItem('autenticacion_token', resultado.info.token);
                this.getDecodedToken();
                this.confirmacion.estatus = true;
                this.confirmacion.mensaje = resultado.mensaje;
            }
            else {
                this.confirmacion.estatus = false;
                this.confirmacion.mensaje = resultado.mensaje;
            }
            return this.confirmacion;
        }));
    }
    logout() {
        // remove resultado from local storage to log resultado out
        localStorage.clear();
    }
    getDecodedToken() {
        const token = localStorage.getItem('autenticacion_token');
        if (!token || this.userSirvice.getUserInfo().rol != null)
            return null;
        try {
            const userInfo = jwtDecode(token);
            const user = userInfo['userdata'];
            this.userSirvice.setUserInfo(JSON.parse(user));
        }
        catch (error) {
            console.error('Error al decodificar token', error);
            return null;
        }
    }
}
AuthenticationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UserService)); }, token: AuthenticationService, providedIn: "root" });
